import React, { useState, useEffect, useCallback } from "react";
import "../Styles/style.css";
import axios from "axios";
// import Sidebar from "./sideBar";
import AdsResult from "./adsResult";
import { baseUrl } from "../../api/ipconfig";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Pagination from "@mui/material/Pagination";
import Sidebar from "./sideBar copy";
import { Link, useLocation } from "react-router-dom";

export default function BikeSearchResult() {
  const [vehicleCategory, setVehicleCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [freeAdCount, setFreeAdCount] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const selectedAdType = queryParams.get("at");
  const selectedMake = queryParams.get("mk");
  const selectedModel = queryParams.get("md");
  const selectedYear = queryParams.get("year");
  const selectedCity = queryParams.get("ct");
  const selectedCategories = queryParams.get("ctg");
  const selectedCondition = queryParams.get("cnd");
  const selectedMinPrice = queryParams.get("mnp");
  const selectedMaxPrice = queryParams.get("mxp");
  const searchData = queryParams.get("sr");

  const [filters, setFilters] = useState({
    search: null,
    condition: "used",
    city: 0,
    make: 0,
    model: 0,
    year: 0,
    minPrice: 0,
    maxPrice: 50000000,
    category: 0,
  });
  const [postData, setPostData] = useState([]);
  const [featuredData, setFeaturedData] = useState([]);

  const searchCategory = selectedCategories;
  const searchAdType = selectedAdType;
  const searchMake = selectedMake;
  const searchModel = selectedModel;
  const searchYear = selectedYear;
  const searchCity = selectedCity;
  const searchCondition = selectedCondition;
  const searchMaxPrice = selectedMaxPrice;
  const searchMinPrice = selectedMinPrice;

  const handleRecall = () => {};

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.get(`${baseUrl}/bycategory`);
        setVehicleCategory(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchFilters();
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleFilterChange = (filterName, value) => {
    setPage(0);
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: value,
    }));
  };

  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const pageSize = 30;
  const handleChange = (event, value) => {
    setPage(value);
  };

  const user = localStorage.getItem("data");
  const userId = JSON.parse(user)?.id;

  const fetchData = useCallback(
    async (filters, page) => {
      try {
        setLoading(true);
        const category = filters.category || searchCategory || 0;
        const search = filters.search || searchData || " ";
        const make = filters.make || [searchMake] || 0;
        const model = filters.model || [searchModel] || [];
        const year = filters.year || [searchYear] || [];
        const city = filters.city || [searchCity] || 0;
        const mileage = filters.mileage || 0;
        const fule = filters.fule || "";
        const add = filters.add || searchAdType || "";
        const minPrice = filters.minPrice || searchMinPrice;
        const maxPrice = filters.maxPrice || searchMaxPrice;

        const response = await axios.get(`${baseUrl}/bike-filter-post`, {
          params: {
            page: page,
            search_name: search,
            city_name: city,
            makeName: make,
            modelName: model,
            year_id: year,
            price_from: minPrice,
            price_to: maxPrice,
            engine_capacity: category,
            mileage: mileage,
            enginetype: fule,
            addtype: add,
            condition: "used",
          },
        });

        setPostData(response?.data?.posts?.data);
        setFeaturedData(response?.data?.featured_adds?.data);
        setTotalPages(response?.data?.posts?.last_page);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    },
    [
      searchCategory,
      searchMake,
      searchCity,
      searchCondition,
      userId,
      searchData,
    ]
  );
  useEffect(() => {
    fetchData(filters, page);
  }, [fetchData, filters, page]);

  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  return (
    <>
      <div className=" colorBg_new d-none d-lg-block "></div>

      <div>
        <div className="container d-none d-lg-block pt-3 pb-2 trasnsitionAll ">
          {/* Search Page Top Ad */}
          <div
            id="div-gpt-ad-1743150662964-0"
            style={{ minWidth: "970px", minHeight: "90px" }}
          ></div>
          <Sidebar
            vehicleCategory={vehicleCategory}
            onCategoryChange={handleCategoryChange}
            selectedFilters={filters}
            onFilterChange={handleFilterChange}
          />
        </div>
      </div>
      <div className="used_main text-center p-5 d-none">
        <div className="container h-100 d-flex justify-content-end align-items-center">
          <h3>Search Cars In Pakistan</h3>
        </div>
      </div>

      <div className="d-block d-lg-none">
        <Sidebar
          vehicleCategory={vehicleCategory}
          onCategoryChange={handleCategoryChange}
          selectedFilters={filters}
          onFilterChange={handleFilterChange}
        />
      </div>
      <div className="filter_main">
        <div className="mt-3">
          <div className="container  justify-content-start align-items-center mb-4">
            <h1 className=" filtersHead  fw-600 mb-0">
              {freeAdCount} Used {selectedMake ? selectedMake : "Bikes"} for
              Sale in {selectedCity ? `${selectedCity}, Pakistan` : "Pakistan"}
            </h1>
            <p className="filter_main_info">
              Looking to{" "}
              <Link to={`/used-bikes/sell`}> Sell your bike in Pakistan</Link>{" "}
              instead? Post an ad on FameWheels and sell your bike in Pakistan
              for FREE.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="row mb-5 mt-2">
            <div className="col-lg-9 col-12">
              <AdsResult
                selectedCategory={selectedCategory}
                postData={postData}
                featuredData={featuredData}
                fetchData={handleRecall}
                loading={loading}
              />
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChange}
                color="secondary"
              />
            </div>
            <div
              className="col-lg-3 col-12 d-none d-md-block position-relative"
              style={{ zIndex: -1 }}
            >
              <div
                className="  "
                style={{
                  height: 900,
                  position: "sticky",
                  top: 150,
                  zIndex: -2,
                }}
              >
                {/* Search Page Side Bar Ad */}
                <div
                  id="div-gpt-ad-1743151189653-0"
                  style={{
                    minHeight: "600px",
                    minWidth: "300px",
                  }}
                >
                  Ad
                </div>
                <div
                  id="div-gpt-ad-1743151320186-0"
                  style={{
                    minHeight: "250px",
                    minWidth: "300px",
                  }}
                >
                  Ad
                </div>
                <ins
                  className="adsbygoogle"
                  style={{
                    display: "inline-block",
                    width: "300px",
                    height: "800px",
                  }}
                  data-ad-client="ca-pub-3390551153563969"
                  data-ad-slot="2905132142"
                ></ins>
              </div>
            </div>
          </div>
          {/* Search Page Mobile Ad */}
          <div
            id="div-gpt-ad-1740120362045-0"
            style={{ minHeight: "50px" }}
          ></div>
        </div>
      </div>
    </>
  );
}
